import api from '../instance';
import { IHelpCenterCategory, IHelpCenterTopic } from '../../store/types/helpCenter';

interface IFetchCategoriesParams {
  per_page?: number;
  page?: number;
}

interface ISendUsefulData {
  flag: number;
}

type TFetchCategoriesResponse = {
  data: IHelpCenterCategory[];
  meta: {
    currentPage: string;
    lastPage: string;
    perPage: string;
    from: string;
    to: string;
    total: string;
  };
};

type TFetchTopicsResponse = {
  data: IHelpCenterTopic[];
};

export default {
  getCategories: (params: IFetchCategoriesParams): Promise<TFetchCategoriesResponse> =>
    api.get('help-center/category', { params }),
  getTopics: (): Promise<TFetchTopicsResponse> => api.get('help-center/topic'),
  sendUseful: (slug: string, data: ISendUsefulData): Promise<IHelpCenterTopic> =>
    api.put(`help-center/topic/${slug}/useful`, data),
};
